import React, { Component } from 'react'
import PropTypes from 'prop-types'
import remove from 'lodash/remove'

const scrollSpy = Child =>
  class ScrollSpy extends Component {
    static childContextTypes = {
      addAnchor: PropTypes.func,
      removeAnchor: PropTypes.func,
      changeCurrent: PropTypes.func
    }

    addAnchor = anchor => {
      if (this.anchors.length === 0) {
        this.changeCurrent(anchor.name)
      }
      this.anchors.push(anchor)
    }

    removeAnchor = anchor => {
      remove(this.anchors, a => a === anchor)
    }

    getChildContext() {
      return this._context
    }

    constructor(props) {
      super(props)
      this.anchors = []
      this.state = {
        current: null
      }
      this._context = {
        addAnchor: this.addAnchor,
        changeCurrent: this.changeCurrent,
        removeAnchor: this.removeAnchor
      }
    }

    scrollByHash() {
      if (this.props.location && this.props.location.hash) {
        const name = this.props.location.hash.slice(1)
        const anchor = this.anchors.find(anchor => anchor.getAttribute('name') === name)
        if (anchor) {
          anchor.scrollIntoView()
          this.changeCurrent(name)
        }
      }
    }

    componentDidMount() {
      window.addEventListener('scroll', this.handleScroll)
      this.scrollByHash()
    }

    componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll)
    }

    changeCurrent = current => {
      this.setState({ current })
    }

    handleScroll = () => {
      const { current } = this.props
      window.anchors = this.anchors
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      const windowHeight = window.innerHeight
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop

      if (this.anchors.length === 0) {
        return
      }
      let currentAnchor = this.anchors[0]
      if (!currentAnchor) {
        return
      }
      let currentAnchorTop = this.anchors[0].getBoundingClientRect().top
      for (let anchor of this.anchors) {
        const top = anchor.getBoundingClientRect().top - 10
        if (top <= 0 && (top > currentAnchorTop || currentAnchorTop > 0)) {
          currentAnchorTop = top
          currentAnchor = anchor
        }
      }
      if (windowHeight + scrollTop >= scrollHeight - 10) {
        currentAnchor = this.anchors[this.anchors.length - 1]
      }
      const { name } = currentAnchor
      if (current !== name) {
        this.changeCurrent(name)
      }
    }

    render() {
      return <Child current={this.state.current} {...this.props} />
    }
  }

export class AnchorTarget extends Component {
  static contextTypes = {
    addAnchor: PropTypes.func,
    removeAnchor: PropTypes.func
  }
  componentDidMount() {
    this.context.addAnchor(this._a)
  }
  componentWillUnmount() {
    this.context.removeAnchor(this._a)
  }

  render() {
    return <a name={this.props.name} id={this.props.name} ref={a => (this._a = a)} />
  }
}

export const AnchorLink = ({ children, name, ...rest }, { changeCurrent }) => (
  <a {...rest} href={`#${name}`} onClick={() => setTimeout(changeCurrent, 0, name)}>
    {children}
  </a>
)
AnchorLink.contextTypes = {
  changeCurrent: PropTypes.func
}

export default scrollSpy
